document.addEventListener("DOMContentLoaded", function() {
  const select = document.getElementById("inquiry-select");

  select.addEventListener("change", function() {
    const url = this.value;
    if (url) window.location.href = url;
  });
});


document.addEventListener("change", function (e) {
  const select = e.target.closest("select.full");
  if (!select) return;
  const wrapper = select.closest(".small-12");
  if (!wrapper) return;

  const innerForms = wrapper.querySelector(".inner-forms");
  const innerSelect = wrapper.querySelector(".inner-forms select");
  const subForm = wrapper.querySelector(".sub_form");
  const subSelect = wrapper.querySelector(".sub_form select");

  if (select.name.includes("contact[") && innerForms && !select.closest(".inner-forms")) {
    const val = select.value.trim().toLowerCase();

    if (val === "yes") {
      innerForms.classList.add("active_inner");
    } else {
      innerForms.classList.remove("active_inner");
      innerForms.classList.remove("active_sub");
      if (innerSelect) innerSelect.selectedIndex = 0;
      if (subSelect) subSelect.selectedIndex = 0;
    }
  }
  if (select.closest(".inner-forms") && !select.closest(".sub_form")) {
    const val = select.value.trim();

    if (val === "Not what I wanted/expected") {
      innerForms.classList.add("active_sub");
    } else {
      innerForms.classList.remove("active_sub");
      if (subSelect) subSelect.selectedIndex = 0;
    }
  }
});

